(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-mobile-header"] && !Shopify.designMode) return;
  try {
    function compactCollectionDescription(root) {
    root.querySelectorAll('.folders-collection-mobile__full').forEach(content => {
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (node.nodeType === 3) return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          if (['META', 'LINK', 'STYLE', 'SCRIPT'].includes(node.tagName)) return NodeFilter.FILTER_REJECT;
          return node.matches('img, svg, video, audio, iframe, hr, table') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      const firstContent = walker.nextNode();
      for (let start = firstContent && (firstContent.nodeType === 1 ? firstContent : firstContent.parentElement); start && start !== content; start = start.parentElement) {
        start.classList.add('folders-collection-mobile__content-start');
      }
      let lastContent = firstContent;
      for (let next = walker.nextNode(); next; next = walker.nextNode()) lastContent = next;
      for (let end = lastContent && (lastContent.nodeType === 1 ? lastContent : lastContent.parentElement); end && end !== content; end = end.parentElement) {
        end.classList.add('folders-collection-mobile__content-end');
      }
      let tail = content.lastChild;
      while (tail) {
        if (tail.nodeType === 8 || (tail.nodeType === 3 && !tail.textContent.trim())) {
          tail = tail.previousSibling;
          continue;
        }
        if (tail.nodeType !== 1) break;
        const plainAttributes = Array.from(tail.attributes).every(attribute =>
          attribute.name === 'style' || (attribute.name === 'class' &&
            Array.from(tail.classList).every(name => name === 'folders-collection-mobile__empty-tail'))
        ) && Array.from(tail.style).every(property => property === 'text-align');
        const emptyBlock = ['P', 'DIV'].includes(tail.tagName) && plainAttributes &&
          Array.from(tail.childNodes).every(node =>
            (node.nodeType === 3 && !node.textContent.trim()) ||
            (node.nodeType === 1 && node.tagName === 'BR')
          );
        if (!emptyBlock) {
          tail.classList.add('folders-collection-mobile__content-end');
          break;
        }
        tail.classList.add('folders-collection-mobile__empty-tail');
        tail = tail.previousSibling;
      }
    });
  }
  compactCollectionDescription(document);
  document.addEventListener('shopify:section:load', event => compactCollectionDescription(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-category-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-category-scroll')) {
    customElements.define('search-category-scroll', class extends HTMLElement {
      connectedCallback() {
        this.rails = Array.from(this.querySelectorAll('[data-search-category-rail]'));
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.primaryList = this.querySelector('.search-category-navigation__primary');
        this.remainingList = this.querySelector('.search-category-navigation__remaining');
        this.remainingLinks = this.remainingList ? Array.from(this.remainingList.children) : [];
        this.update = () => {
          const target = this.mobile.matches ? this.remainingList : this.primaryList;
          this.remainingLinks.forEach(link => {
            if (link.parentElement !== target) target.appendChild(link);
          });
          let hasOverflow = false;
          this.rails.forEach(rail => {
            const list = rail.querySelector('[data-search-category-list]');
            const button = rail.querySelector('[data-search-category-next]');
            const first = list.firstElementChild;
            const last = list.lastElementChild;
            const contentWidth = first && last ? last.getBoundingClientRect().right - first.getBoundingClientRect().left + 6 : 0;
            const overflow = list.clientWidth > 0 && contentWidth > list.clientWidth + 2;
            const canForward = overflow && list.scrollWidth - list.clientWidth - list.scrollLeft > 2;
            rail.toggleAttribute('data-overflow', overflow);
            rail.toggleAttribute('data-can-forward', canForward);
            button.hidden = !overflow;
            button.disabled = !canForward;
            hasOverflow = hasOverflow || overflow;
          });
          const hint = this.querySelector('[data-search-category-swipe-hint]');
          if (hint) hint.hidden = !hasOverflow;
        };
        this.advance = event => {
          const button = event.target.closest('[data-search-category-next]');
          if (!button || !this.contains(button)) return;
          const list = button.closest('[data-search-category-rail]').querySelector('[data-search-category-list]');
          list.scrollBy({
            left: Math.max(120, list.clientWidth * 0.75),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        };
        this.revealFocusedCategory = event => {
          const link = event.target.closest('.search-category-navigation__link');
          if (!link || !link.matches(':focus-visible')) return;
          const rail = link.closest('[data-search-category-rail]');
          if (rail && rail.hasAttribute('data-overflow')) {
            link.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'instant' });
          }
        };
        this.rails.forEach(rail => rail.querySelector('[data-search-category-list]').addEventListener('scroll', this.update, { passive: true }));
        this.mobile.addEventListener('change', this.update);
        this.addEventListener('click', this.advance);
        this.addEventListener('focusin', this.revealFocusedCategory);
        this.addEventListener('toggle', this.update, true);
        this.observer = new ResizeObserver(this.update);
        this.rails.forEach(rail => this.observer.observe(rail.querySelector('[data-search-category-list]')));
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.rails) this.rails.forEach(rail => rail.querySelector('[data-search-category-list]').removeEventListener('scroll', this.update));
        if (this.mobile) this.mobile.removeEventListener('change', this.update);
        this.remainingLinks.forEach(link => this.remainingList.appendChild(link));
        this.removeEventListener('click', this.advance);
        this.removeEventListener('focusin', this.revealFocusedCategory);
        this.removeEventListener('toggle', this.update, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
